import React from "react";
import styled, { theme } from "../styled";
import withMargin, { WithMarginProp } from "../styled/withMargin";
import { Text } from "../design-system/components/Text";
import { Stack } from "./Stack";
import NHSNoText from "../icons/NHSNoText";
import { trackEvent } from "../analytics";

const Anchor = styled.a`
  font-family: ${theme.typography.bodyFamily};
  font-weight: ${theme.typography.weight.bold};
  font-size: ${theme.typography.size.m};
  line-height: ${theme.typography.lineHeight.m};
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 170px;
  width: 100%;
  border: none;
  cursor: pointer;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  border-radius: 5px;
  height: 50px;
  padding: 0 ${theme.spacing.m};
  transition: background-color 0.2s, box-shadow 0.2s;

  background: ${theme.nhslogincolor.blue};
  color: ${theme.nhslogincolor.blue};

  &:hover:not(:disabled) {
    background: ${theme.nhslogincolor.highlight};
  }

  &:active:not(:disabled) {
    background: ${theme.nhslogincolor.highlight};
  }

  &:focus {
    background: ${theme.nhslogincolor.highlight};
  }

  ${withMargin}
`;

type Props = WithMarginProp & {
  type?: "login" | "signup" | "signup_continue";
  href: string;
};

export function NHSLoginButton({ href, type }: Props) {
  return (
    <Anchor
      href={href}
      onClick={() => {
        if (type === "login") {
          trackEvent("login", { auth_type: "nhs_login" });
        } else if ("signup_continue") {
          trackEvent("signup_nhs_login_continue");
        } else {
          trackEvent("signup_started", { auth_type: "nhs_login" });
        }
      }}
    >
      <Stack distribution="between">
        <div
          style={{
            marginRight: theme.spacing.s,
            display: "flex",
            justifyContent: "center"
          }}
        >
          <NHSNoText />
        </div>
        <Text isBold={true} color="white">
          {type === "signup"
            ? "Sign up with NHS login"
            : "Continue with NHS login"}
        </Text>
      </Stack>
    </Anchor>
  );
}
